import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AmortResponse } from '../../shared/models/amortResponse';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import JSZip from 'jszip';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';





export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-amortizationpage',
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatInputModule,SessionTimeoutComponent, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ], templateUrl: './amortization.component.html',
    providers: []
})


export class AmortizationComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  brandId: string;
  amortAccount: string;
  loginAttempt = false;
  disclaimer: string;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  tableLoaded = true;
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  fullDABPaymentScheduleItem = [];
  ciamId = sessionStorage.getItem('loginID');
  accountDetailsRes: Array<AccoutDetailsResponse> = [];
  termAccDetailsRes: Array<AccoutDetailsResponse> = [];
  amortRes: AmortResponse[];
  recAccCount = '';
  totalDue = '';
  selectedValue: string;
  displayValue: string;
  loanAccounts = false;
  AmortSelected = false;
  contractSelected=false;
  contractNumber: string;
  zip = new JSZip();
  loading = false;
  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;

  // Table columns
  initColumns: any[] = [
    {
      name: 'paymentReceiptDate',
      display: 'Payment Date',
      displayFR: 'Date du paiement',
      dispFormat: 'date'
    },
    {
      name: 'paymentType',
      display: 'Payment Type',
      displayFR: 'Type de paiement',
      dispFormat: ''
    },
    {
      name: 'totalPayment',
      display: 'Total Payment',
      displayFR: 'Paiement total',
      dispFormat: 'currency'
    },
    {
      name: 'principalAmount',
      display: 'Principal Amount',
      displayFR: 'Le montant principal',
      dispFormat: 'currency'
    },
    {
      name: 'interestAmount',
      display: 'Interest Amount',
      displayFR: 'Montant des intérêts',
      dispFormat: 'currency'
    },
    {
      name: 'otherFee',
      display: 'Other Fees',
      displayFR: 'Autres frais',
      dispFormat: 'currency'
    },
    {
      name: 'outStandingBalance',
      display: 'Outstanding Balance',
      displayFR: 'Montant du solde',
      dispFormat: 'currency'
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

//Account Details columns
accountinitColumns: any[] = [
  {
    name: 'select',
    display: '',
    displayMobile: '',
    displayFR: '',
    dispFormat: ''
  },
  {
    name: 'contractNum',
    display: 'Account',
    displayFR: 'Numéro de compte',
    dispFormat: ''
  },
  {
    name: 'lastPayRcvd',
    display: 'Last Payment',
    displayFR: 'Dernier versement',
    dispFormat: 'currency'
  },
  {
    name: 'contractType',
    display: 'Account Type',
    displayFR: 'Type de compte',
    dispFormat: ''
  },
  {
    name: 'termDate',
    display: 'Maturity Date',
    displayFR: 'Date d\'échéance',
    dispFormat: ''
  }
];
accountdisplayedColumns: any[] = this.accountinitColumns.map(col => col.name);

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';

  // Form region.
  
  dataSource: MatTableDataSource<AmortResponse>;
  accountdataSource: MatTableDataSource<AccoutDetailsResponse>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(false, []);

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil,public dialog: MatDialog

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.amortRes = [];
    this.dataSource = new MatTableDataSource(this.amortRes);
  }

  ngAfterViewInit() {
    if (this.accountdataSource) {
      this.accountdataSource.paginator = this.paginator;
      this.accountdataSource.sort = this.sort;
    }
  }
  ngOnInit() {
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
    this.getAccountDetailsListByUserId();
    //this.getAlerts();
  }
  
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

 
  
  getAccountDetailsListByUserId() {
  
    const accountDetailsRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
  
    forkJoin({
      activeAccounts: this.auth.getAccountDetailsListByUserId(accountDetailsRequest),
      terminatedAccounts: this.auth.getTerminatedAccounts(accountDetailsRequest)
    }).subscribe(({ activeAccounts, terminatedAccounts }) => {
  
      const loanAccounts = [
        ...activeAccounts.accountdetailsList,
        ...terminatedAccounts.accountdetailsList
      ].filter(acc => acc.contractType === 'LOAN');
  
      this.loanAccounts = loanAccounts.length > 0;
      this.accountDetailsRes = loanAccounts;
  
      this.accountdataSource = new MatTableDataSource(this.accountDetailsRes);
      setTimeout(() => {
       this.accountdataSource.paginator = this.paginator;
       this.accountdataSource.sort = this.sort;
      });
  
      this.accountdataSource.filterPredicate = (data: any, filter: string) => {
        const value = filter.trim().toLowerCase();
        return (
          data.contractNum?.toLowerCase().includes(value) ||
          data.status?.toLowerCase().includes(value) ||
          data.contractType?.toLowerCase().includes(value)
        );
      };
  
      this.rowCount = this.accountdataSource.filteredData.length;
      this.dbLoaded = true;
      this.filter = true;
    });
  }
  

  
  async downloadFile(blob: Blob, fileName: string): Promise<string> {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Clean up
    return fileName;
  }



async downloadAll() {
  this.loading = true;
    try {
        const zip = await this.downloadAll1();
        const zipBlob: Blob = await zip.generateAsync({ type: 'blob' });

        // Step 4: Trigger file download
        const data: string = await this.downloadFile(zipBlob, 'documents.zip');
    } catch (error) {
        console.error("Error downloading files:", error);
    }
    this.loading = false;
}

async downloadAll1(): Promise<JSZip> {
  try {
      let zip = new JSZip(); // Define zip only once outside the loop

      for (let i = 0; i < this.accountDetailsRes.length; i++) {
        this.contractNumber=this.accountDetailsRes[i].contractNum.substring(0, 10);
          const amortRequest = {
              "contractNumber": this.accountDetailsRes[i].contractNum.substring(0, 10),
              "scheduleNumber": "001"
          };

          try {
              // Await the result of getAmort
              const res = await this.auth.getAmort(amortRequest).toPromise();
              this.amortRes = res;
              this.tableLoaded = true;
              this.dataSource = new MatTableDataSource(this.amortRes);
              this.dataSource.paginator = this.paginator;

              // Wait for data to load before exporting
              await new Promise(resolve => setTimeout(resolve, 500));

              this.dbLoaded = true;
              this.filter = true;
              this.rowCount = this.dataSource.filteredData.length;
              this.dataSource.sort = this.sort;

              // Append each PDF to the zip instead of overwriting
              zip = await this.exportToPdf(zip, `${this.accountDetailsRes[i].contractNum.substring(0, 10)}.pdf`);
          } catch (error) {
              console.error(`Error processing document ${i}:`, error);
          }
      }

      // After all files are added, return the final zip object
      return zip;
  } catch (error) {
      console.error('Error creating ZIP:', error);
      throw error; // Ensure errors are caught in downloadAll()
  }
}


async exportToPdf(zip: JSZip, fileName: string): Promise<JSZip> {
  const pdfData = await this.exportZip(); // Assuming this generates PDF data
  zip.file(fileName, pdfData, { binary: true }); // Add file to zip
  return zip; // Return the modified zip instance
}

exportZip(): Promise<Uint8Array>{
  // this.translate.get('Amortization.Disclaimer3').subscribe((datedisclaimer: any) => {
  // this.disclaimer = datedisclaimer;
  // });
  return new Promise((resolve) => {

  var Header =[];
  if(this.isFrench){
    Header = [
      ["Date du paiement", "Type de paiement", "Le montant principal","Montant des intérêts","Autres frais","Paiement total" ,"Montant du solde"],
    ];
  }else{
    Header = [
      ["Payment Date", "Payment Type","Principal Amount","Interest Amount","Other Fees","Total Payment", "Outstanding Balance"],
    ];
  }
  const doc = new jsPDF('l', 'mm', 'a4'); 
  var rows = [];
  const head = Header;
  const data = this.dataSource.data;
  data.forEach(element => {
    var temp = [element.paymentReceiptDate, element.paymentType, '$'+ element.principalAmount, '$'+ element.interestAmount, '$'+ element.otherFee, '$'+ element.totalPayment, '$'+ element.outStandingBalance]
    rows.push(temp);
  });
  var account = this.contractNumber;
  autoTable(doc, {
      head: head,
      body: rows,
      theme:'grid',
      headStyles :{fillColor : [79, 77, 74]},
      didDrawPage: function (data1) {
        var base64Img= 'data:image/jpeg;base64,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'
       if (base64Img) {
        doc.addImage(base64Img, 'JPEG', data1.settings.margin.left, 15, 50, 10);
       }
       doc.setFontSize(14);
       doc.setTextColor(40);
       doc.text("Amortization Schedule: " + account + '001', data1.settings.margin.left + 51, 22);
       },
     margin: {top: 30}
    });
    const pdfOutput = doc.output('arraybuffer');
    resolve(new Uint8Array(pdfOutput));
  });
}



  

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //       if( this.currentCountry === 'CA'){
  //         if (res[i].bannerType === 'Alert' &&  res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //         res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //         this.alerts = res[i];
  //         this.dbData = true;
  //          }
  //       }
  //       else{
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       }
  //     });
  // }

  


  onAmortSelected(){
    this.tableLoaded=false;
    this.AmortSelected=false;
    this.contractNumber='';
    this.checkSingleToggleSelected(); //checks select Box
    if(this.contractSelected){
      this.getAmort(this.contractNumber);
     }
   }

   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

   checkSingleToggleSelected(){
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('amortdialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;  
      this.tableLoaded = true;
      }
    else{
      this.contractNumber =this.selection.selected[0].contractNum.substring(0, this.selection.selected[0].contractNum.length-3);
      this.contractSelected = true;
    }   
   }

     /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.accountdataSource.data.forEach(row => this.selection.select(row));
  }

  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.accountdataSource.filter = filterValue.trim().toLowerCase();
    if (this.accountdataSource.paginator) {
      this.accountdataSource.paginator.firstPage();
    }
    this.rowCount = this.accountdataSource.filteredData.length;
  }





  getAmort(contract: any) {
  const amortRequest = {
   "contractNumber":this.contractNumber,
   "scheduleNumber":"001"   
  };
  this.auth.getAmort(amortRequest).subscribe(res => {
      this.amortRes = res;
      this.tableLoaded = true;
      this.AmortSelected=true;
      this.dataSource = new MatTableDataSource(this.amortRes);
      // this.dataSource.paginator = this.paginator;
      setTimeout(() => {
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
        this.dataSource.sort = this.sort;
      });
    });
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  ExportTOExcel()
  {
    var Header =[];
      const workSheet = XLSX.utils.book_new();
      if(this.isFrench){
        Header = [
          ["","","","Date du paiement", "Type de paiement", "Le montant principal","Montant des intérêts","","Autres frais","Paiement total" ,"Montant du solde"],
        ];
      }else{
        Header = [
          ["","","","Payment Date", "Payment Type","Principal Amount","Interest Amount", "","Other Fees","Total Payment", "Outstanding Balance"],
        ];
      }
    
      XLSX.utils.sheet_add_aoa(workSheet, Header);
      
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(workSheet, this.dataSource.data, { origin: 'A2', skipHeader: true });
      const workBook: XLSX.WorkBook = XLSX.utils.book_new();

      workSheet['!cols'] = [];
      workSheet['!cols'][0] = { hidden: true }; 
      workSheet['!cols'][1] = { hidden: true }; 
      workSheet['!cols'][2] = { hidden: true }; 
      workSheet['!cols'][7] = { hidden: true };      

      XLSX.utils.book_append_sheet(workBook, workSheet, 'Amortization Schedule');
      
      /* save to file */
      XLSX.writeFile(workBook,  this.contractNumber + '001.xlsx');
  }  

  exportTable(){
    // this.translate.get('Amortization.Disclaimer3').subscribe((datedisclaimer: any) => {
    // this.disclaimer = datedisclaimer;
    // });

    var Header =[];
    if(this.isFrench){
      Header = [
        ["Date du paiement", "Type de paiement", "Le montant principal","Montant des intérêts","Autres frais","Paiement total" ,"Montant du solde"],
      ];
    }else{
      Header = [
        ["Payment Date", "Payment Type","Principal Amount","Interest Amount","Other Fees","Total Payment", "Outstanding Balance"],
      ];
    }
    const doc = new jsPDF('l', 'mm', 'a4'); 
    var rows = [];
    const head = Header;
    const data = this.dataSource.data;
    data.forEach(element => {
      var temp = [element.paymentReceiptDate, element.paymentType, '$'+ element.principalAmount, '$'+ element.interestAmount, '$'+ element.otherFee, '$'+ element.totalPayment, '$'+ element.outStandingBalance]
      rows.push(temp);
    });
    var account = this.contractNumber;
    const isFrench = this.isFrench;
    autoTable(doc, {
        head: head,
        body: rows,
        theme:'grid',
        headStyles :{fillColor : [79, 77, 74]},
        didDrawPage: function (data1) {
          var base64Img= 'data:image/jpeg;base64,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'
         if (base64Img) {
          doc.addImage(base64Img, 'JPEG', data1.settings.margin.left, 15, 50, 10);
         }
         doc.setFontSize(14);
         doc.setTextColor(40);
         if(isFrench){
          doc.text("Tableau d'amortissement: " + account + '001', data1.settings.margin.left + 51, 22);
         }else{
          doc.text("Amortization Schedule: " + account + '001', data1.settings.margin.left + 51, 22);
         }
         },
       margin: {top: 30}
      });
    doc.save(account + '001.pdf');
  }

 
  amortRedirect(e: Event) {
      let redirect = '';
      this.translate.get('LoginModal.AmortRedirect').subscribe((data:any)=> {
        redirect= this.usUrl +  data;
       });
       window.location.href = redirect;
    }
  
    openDialog(num:any): void {
      if(num===5){
        sessionStorage.setItem('amortdialog', 'error');
      }

    let dialogRef = this.dialog.open(AmortDialogComponent, {
      maxWidth: '200vw',
      width: '500px',
    });
  
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  }
  

  @Component({
    selector: 'dialog-amortPopup',
    imports: [MatButtonModule,MatDialogContent, MatDialogActions,
        MatDialogClose],
    templateUrl: 'amortPopupDialog.component.html'
})
  export class AmortDialogComponent {
    usUrl: string;
    caUrl: string;
    amortdialog: string;
    errorMessage: string;
    constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
      private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog
  
    ) {
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
      this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
      this.amortdialog = sessionStorage.getItem('amortdialog');
       this.auth.cast3.subscribe((errorMessage:any)=> {
        this.errorMessage = errorMessage;
       });
    }
  }
  
